import {Component} from 'react';
import {createPortal} from 'react-dom';
import PropTypes from 'prop-types';
import DOMUtils from '@livongo/utils/dom';

export default class Portal extends Component {
    static propTypes = {
        /** Additional class(es) to add to the component. */
        className: PropTypes.string,
        /** The element(s) to render. */
        children: PropTypes.element.isRequired,
    };

    constructor(props) {
        super(props);

        const {className} = props;

        this._container = document.createElement('div');

        if (className) {
            DOMUtils.addClass(this._container, className);
        }

        document.body.appendChild(this._container);
    }

    componentWillUnmount() {
        document.body.removeChild(this._container);
    }

    render() {
        return createPortal(this.props.children, this._container);
    }
}
